import { isChatAsset, isFileAsset, type ModalAssetItem } from '~/features/chat/modal-asset';
import type { WindowKind } from '~/lib/stores/window-rules';

/** The window bar's label for whatever a chat-kind window shows. */
export function assetWindowTitle(item: ModalAssetItem): string {
  if (isChatAsset(item)) return item.directAgent?.name ?? (item.title?.trim() || 'New chat');
  if (isFileAsset(item)) return item.name?.trim() || 'File';
  return item.title?.trim() || item.jobName?.trim() || 'Briefing';
}

/** Window id for a chat-kind window: one window per asset/session. */
export function chatWindowId(item: ModalAssetItem): string {
  return `chat:${item.id}`;
}

/** Window id for a Build window: one per session, or the shared "resume the latest" slot. */
export function buildWindowId(sessionId: string | null | undefined): string {
  return `build:${sessionId ?? 'latest'}`;
}

/** FRONT-3171: one window per file of a Build project. */
export function fileWindowId(sessionId: string, path: string): string {
  return `file:${sessionId}:${path}`;
}

/** One window per uploaded file (a message attachment). */
export function uploadWindowId(fileId: string): string {
  return `file:upload:${fileId}`;
}

/** The file's own name, for its tab ("docs/BRIEF.md" → "BRIEF.md"). */
export function fileWindowTitle(path: string): string {
  return path.split('/').pop() || path;
}

/** One window per app: its Preview, opened from the Build that made it. */
export function appWindowId(slug: string): string {
  return `app:${slug}`;
}

export const PRO_BUILDER_WINDOW_ID = 'pro-builder';

/** One Settings window at a time: its section lives in the payload, not the id. */
export const SETTINGS_WINDOW_ID = 'settings';

/** One System Settings window at a time, for the same reason. */
export const SYSTEM_SETTINGS_WINDOW_ID = 'system-settings';

export const WINDOW_KIND_LABEL: Record<WindowKind, string> = {
  chat: 'Chat',
  build: 'Build',
  'pro-builder': 'Pro Builder',
  settings: 'Settings',
  'system-settings': 'System Settings',
  file: 'File',
  app: 'App',
};
